import '../style.css';

const FailedResponse = ()=>{
    return (
        <div className='container'>
            <div className='response-overlay'>
            <div className='response-box'>
            <div className='error-response'>
    <p>Verification Error</p>
    <div className='description'>
    We’ve encountered an issue, but we’re here to help! 
    <br></br><br/>
    You will need to reach out to T-Mobile’s CLEAR support. 
    Please refer back to the email from T-Mobile that brought you to this CLEAR registration page. 
    </div>
    </div>
            </div>
            </div>
    </div>

    )

};

export default FailedResponse;